export default {
  //get all TAGs
  GET_SUPERADMIN_BUCKETS_REQUEST: "GET_SUPERADMIN_BUCKETS_REQUEST",
  GET_SUPERADMIN_BUCKETS_SUCCESS: "GET_SUPERADMIN_BUCKETS_SUCCESS",
  GET_SUPERADMIN_BUCKETS_FAIL: "GET_SUPERADMIN_BUCKETS_FAIL",

  //edit TAGs
  EDIT_SUPERADMIN_BUCKET_REQUEST: "EDIT_SUPERADMIN_BUCKET_REQUEST",
  EDIT_SUPERADMIN_BUCKET_SUCCESS: "EDIT_SUPERADMIN_BUCKET_SUCCESS",
  EDIT_SUPERADMIN_BUCKET_FAIL: "EDIT_SUPERADMIN_BUCKET_FAIL",

  //create TAG
  CREATE_SUPERADMIN_BUCKET_REQUEST: "CREATE_SUPERADMIN_BUCKET_REQUEST",
  CREATE_SUPERADMIN_BUCKET_SUCCESS: "CREATE_SUPERADMIN_BUCKET_SUCCESS",
  CREATE_SUPERADMIN_BUCKET_FAIL: "CREATE_SUPERADMIN_BUCKET_FAIL",

  DELETE_SUPERADMIN_BUCKET_REQUEST: "DELETE_SUPERADMIN_BUCKET_REQUEST",
  DELETE_SUPERADMIN_BUCKET_SUCCESS: "DELETE_SUPERADMIN_BUCKET_SUCCESS",
  DELETE_SUPERADMIN_BUCKET_FAIL: "DELETE_SUPERADMIN_BUCKET_FAIL",

  GET_SUPERADMIN_BUCKET_REQUEST: "GET_SUPERADMIN_BUCKET_REQUEST",
  GET_SUPERADMIN_BUCKET_SUCCESS: "GET_SUPERADMIN_BUCKET_SUCCESS",
  GET_SUPERADMIN_BUCKET_FAIL: "GET_SUPERADMIN_BUCKET_FAIL",

  ENABLE_SUPERADMIN_BUCKET_REQUEST: "ENABLE_SUPERADMIN_BUCKET_REQUEST",
  ENABLE_SUPERADMIN_BUCKET_SUCCESS: "ENABLE_SUPERADMIN_BUCKET_SUCCESS",
  ENABLE_SUPERADMIN_BUCKET_FAIL: "ENABLE_SUPERADMIN_BUCKET_FAIL",

  RESTRICT_SUPERADMIN_BUCKET_REQUEST: "RESTRICT_SUPERADMIN_BUCKET_REQUEST",
  RESTRICT_SUPERADMIN_BUCKET_SUCCESS: "RESTRICT_SUPERADMIN_BUCKET_SUCCESS",
  RESTRICT_SUPERADMIN_BUCKET_FAIL: "RESTRICT_SUPERADMIN_BUCKET_FAIL",

  //loading
  ADD_SUPERADMIN_BUCKETS_LOADING: "ADD_SUPERADMIN_BUCKETS_LOADING",
};
